import { render } from "./ViewSupplier.vue?vue&type=template&id=166bed88&scoped=true"
import script from "./ViewSupplier.vue?vue&type=script&lang=js"
export * from "./ViewSupplier.vue?vue&type=script&lang=js"

import "./ViewSupplier.vue?vue&type=style&index=0&id=166bed88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166bed88"]])

export default __exports__